export const authRoutes = {
  login: '/',
  resetPassword: '/reset-password',
};

export const dashboardRoutes = {
  root: '/dashboard',
  admins: 'admins',
  passes: 'passes',
  visits: 'visits',
  venues: 'venues',
  venuesNonPartner: 'venues-non-partner',
  venueDetails: 'venues/:id',
  venueDetailsEdit: 'venues/:id/edit',
  venueSetup: 'venue-setup',
  venueNonPartnerSetup: 'venue-non-partner-setup',
  venueProfile: 'venue-profile',
  venueProfileEdit: 'venue-profile/:id',
  venueGroups: 'venue-groups',
  venueGroupDetails: 'venue-groups/:id',
  promoCodes: 'promo-codes',
};

export const buildPath = (segments: (string | number)[]) => segments.join('/');
